/* I campi che compaiono solo quando servono.
 *
 * Nel modulo dei contatti una tendina dichiara di comandare (data-radar-trigger)
 * e alcuni campi dichiarano da quale sua scelta dipendono (data-show-when).
 * Chiedere il numero d'ordine a chi scrive per un preventivo, o la partita IVA
 * a chi ha un problema con una consegna, allunga il modulo e fa scappare.
 *
 * Due cose che vanno insieme e che e' facile dimenticare:
 *
 * - un campo nascosto viene comunque inviato, e arriverebbe vuoto nella mail
 *   insieme a tutti gli altri; quindi quando si nasconde si disabilita, e un
 *   campo disabilitato il browser non lo manda affatto;
 * - un campo obbligatorio e nascosto blocca l'invio con un messaggio che nessuno
 *   puo' leggere, perche' punta a una casella che non e' in pagina. Il required
 *   va tolto mentre e' nascosto e rimesso quando torna.
 *
 * Senza JavaScript i campi restano nascosti dal markup, ma il modulo funziona:
 * nome, email e messaggio bastano a scrivere, e il resto lo si chiede
 * rispondendo.
 */
(function () {
  'use strict';

  function fields(form) {
    return form.querySelectorAll('[data-show-when]');
  }

  // Un campo puo' dipendere da piu' di una scelta: il numero d'ordine serve
  // sia a chi ha un problema con una consegna sia a chi chiede la fattura.
  // Le scelte si separano con la virgola, come le voci della tendina - che
  // per questo una virgola dentro non ce l'hanno mai.
  function riguarda(wanted, chosen) {
    // Senza scelte dichiarate il campo e' di tutti: e' lo stesso significato
    // che ha nell'editor lasciare vuota la casella.
    if (!wanted || !wanted.trim()) return true;
    var voci = wanted.split(',');
    for (var i = 0; i < voci.length; i++) {
      if (voci[i].trim() === chosen) return true;
    }
    return false;
  }

  function apply(form, chosen) {
    Array.prototype.forEach.call(fields(form), function (wrap) {
      var show = riguarda(wrap.getAttribute('data-show-when'), chosen);
      wrap.hidden = !show;

      Array.prototype.forEach.call(wrap.querySelectorAll('input, textarea, select'), function (input) {
        input.disabled = !show;
        if (!show) {
          if (input.required) {
            input.dataset.wasRequired = '1';
            input.required = false;
          }
          return;
        }
        if (input.dataset.wasRequired === '1') input.required = true;
      });
    });
  }

  function start(trigger) {
    var form = trigger.closest('form');
    if (!form || form.dataset.radarContact === '1') return;
    form.dataset.radarContact = '1';

    // Il primo giro serve anche al ritorno dal server: dopo un invio fallito il
    // browser puo' riproporre la scelta di prima, e i campi devono ricomparire
    // senza che nessuno tocchi la tendina.
    apply(form, trigger.value);
    trigger.addEventListener('change', function () {
      apply(form, trigger.value);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('select[data-radar-trigger]'), start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
